import mixpanel from "mixpanel-browser"
import { mixpanelProjectToken } from "@web/config/next"
import { TrackAnalyticsEventArgs } from "platform-common/types/extension"

const shouldDebug = process.env.NODE_ENV !== "production"

let isMixpanelInitialized = false

function initMixpanel() {
  if (!mixpanelProjectToken) return false // not configured
  if (isMixpanelInitialized) return true // already initialized

  mixpanel.init(mixpanelProjectToken, {
    debug: shouldDebug,
    api_host: "https://api.mixpanel.com",
    disable_persistence: true,
  })
  isMixpanelInitialized = true

  return true
}

export const identifyUser = (email?: string, tenantId?: string) => {
  if (!initMixpanel()) return
  mixpanel.identify(email)
  tenantId && mixpanel.set_group("tenantId", [tenantId])
}

export const trackAnalyticsEvent = ({ event, ...props }: TrackAnalyticsEventArgs) => {
  if (!initMixpanel()) return
  mixpanel.track(event, props)
}
